// src/features/study/components/PlanTopToolbar.js
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faDownload, faTrash } from "@fortawesome/free-solid-svg-icons";
import "./PlanTopToolbar.scss";

export default function PlanTopToolbar({
  isEditing,
  isGenerating,
  onRewrite, // AI로 재작성 (패널 오픈만, 로직은 다음 단계)
  onHistory, // 수정 히스토리 모달 오픈
  onSave, // 저장 (편집 모드일 때 유효)
  onCopy,
  onDownloadWord,
  onDownloadPDF,
  onDownloadMarkdown,
  onDelete,
  onCancelEdit,
  // AI 재작성 인풋 관련
  rewriteOpen = false,
  rewritePrompt = "",
  onRewritePromptChange,
  onRewriteSubmit,
  rewriteLoading = false,
  onRewriteClose,
}) {
  const [downloadOpen, setDownloadOpen] = React.useState(false);

  // 편집 모드 진입/이탈 시 다운로드 메뉴 자동 닫기
  React.useEffect(() => {
    setDownloadOpen(false);
  }, [isEditing]);

  return (
    <div className="plan-top-toolbar">
      {isEditing ? (
        <div className="plan-top-toolbar__edit-actions">
          <button
            type="button"
            onClick={onCancelEdit}
            disabled={isGenerating}
            className="plan-top-toolbar__secondary-button"
          >
            취소
          </button>
          <button
            type="button"
            onClick={onSave}
            disabled={isGenerating}
            className="plan-top-toolbar__primary-button"
          >
            저장
          </button>
        </div>
      ) : rewriteOpen ? (
        /* AI 수정 모드: 전체 너비 사용 */
        <div className="plan-top-toolbar__rewrite-container">
          <textarea
            value={rewritePrompt}
            onChange={(e) => {
              onRewritePromptChange?.(e.target.value);
              e.target.style.height = "auto";
              e.target.style.height = `${Math.min(e.target.scrollHeight, 200)}px`;
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                e.target.style.height = "auto";
                e.target.style.height = `${Math.min(e.target.scrollHeight, 200)}px`;
              }
            }}
            placeholder="예: 조사 목적을 더 명확하게 하고, 모집 기준을 구체화해줘. 표는 유지해줘."
            rows={2}
            className="plan-top-toolbar__rewrite-textarea"
            autoFocus
          />
          <button
            type="button"
            onClick={onRewriteSubmit}
            disabled={!rewritePrompt.trim() || rewriteLoading}
            className="plan-top-toolbar__primary-button"
          >
            {rewriteLoading ? "생성 중..." : "생성하기"}
          </button>
          <button
            type="button"
            onClick={onRewriteClose}
            disabled={rewriteLoading}
            className="plan-top-toolbar__close-button"
            aria-label="닫기"
          >
            ×
          </button>
        </div>
      ) : (
        /* 일반 모드: 왼쪽/오른쪽 분리 */
        <>
          <div className="plan-top-toolbar__left">
            <button
              type="button"
              onClick={onRewrite}
              disabled={isGenerating}
              className="plan-top-toolbar__primary-button"
            >
              AI 수정
            </button>
            <button
              type="button"
              onClick={onHistory}
              disabled={isGenerating}
              className="plan-top-toolbar__secondary-button"
            >
              수정 히스토리
            </button>
          </div>

          <div className="plan-top-toolbar__right">
            <button
              type="button"
              onClick={onCopy}
              disabled={isGenerating}
              className="plan-top-toolbar__secondary-button"
            >
              <FontAwesomeIcon icon={faCopy} />
              복사
            </button>
            <button
              type="button"
              onClick={onDownloadPDF}
              disabled={isGenerating}
              className="plan-top-toolbar__secondary-button"
            >
              <FontAwesomeIcon icon={faDownload} />
              다운로드
            </button>

            <button
              type="button"
              onClick={onDelete}
              disabled={isGenerating}
              className="plan-top-toolbar__danger-button"
            >
              <FontAwesomeIcon icon={faTrash} />
              삭제
            </button>
          </div>
        </>
      )}
    </div>
  );
}
